define([
	"./3DBrowser",
	"./AddImageToPlaceholder",
	"./AddPage",
	"./Arrow",
	"./Back",
	"./Bold",
	"./Cancel",
	"./CanvasRightMenu",
	"./CompositeTransform",
	"./CopyPage",
	"./CropModePoints",
	"./Dash",
	"./Delete",
	"./Edit",
	"./EditSeparator",
	"./Fill",
	"./FixedHeight",
	"./FixedSize",
	"./FixedWidth",
	"./FlipHorizontal",
	"./FlipVertical",
	"./FontFamily",
	"./FontWeight",
	"./FontSize",
	"./FormatPainter",
	"./Front",
	"./FullScreen",
	"./Group",
	"./Lock",
	"./Link",
	"./Unlock",
	"./UnGroup",
	"./Image",
	"./ImagePlaceholderShape",
	"./ImagePlaceholder",
	"./ImageReplaceIndicator",
	"./ImageReplaceLoadingIndicator",
	"./ImageReset",
	"./ImageUpload",
	"./Indent",
	"./Italic",
	"./ModeCropToShape",
	"./ModeCurve",
	"./ModeLine",
	"./ModePen",
	"./ModePoints",
	"./ModeSelect",
	"./ModeShape",
	"./ModeTextArea",
	"./ModifyPlaceholderPoints",
	"./OrderList",
	"./Outdent",
	"./PaperSize",
	"./Paragraph",
	"./Pdf",
	"./PlaceholderTextAll",
	"./PlaceholderTextLabel",
	"./PlaceholderTextValue",
	"./Print",
	"./Redo",
	"./Rotate90CW",
	"./Rotate90CCW",
	"./Save",
	"./SaveAndFinish",
	"./ScaleImage",
	"./Strikethrough",
	"./ShapeAlignTop",
	"./ShapeAlignLeft",
	"./ShapeAlignRight",
	"./ShapeAlignBottom",
	"./ShapeAlignVCenter",
	"./ShapeAlignHCenter",
	"./ShapeHorizontalDistribute",
	"./ShapeVerticalDistribute",
	"./Stroke",
	"./SnapToGrid",
	"./TypePlaceholder",
	"./TextCenter",
	"./TextColor",
	"./TextLeft",
	"./TextRight",
	"./ToggleAutospace",
	"./ToggleLabels",
	"./Underline",
	"./Undo",
	"./UnorderList",
	"./VerticalBottom",
	"./VerticalCenter",
	"./VerticalTop",
	"./Width",
	"./Zoom"
], function() {
	// Nothing to do other than load all plugins
});
